module.exports = __webpack_public_path__ + "static/media/product-dev-web-first.ae2d409f.png";